// config.js

const bizIcon = "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg";
const imageOne = "https://media.istockphoto.com/id/1147579300/photo/cleaning-residential-driveway.jpg?s=612x612&w=0&k=20&c=wjwZmsY35pMVX4hGgiR55p25Twb53kqGf5PRdVMUE9Q=";
const imageTwo = "https://media.istockphoto.com/id/1012456142/photo/patio-pressure-cleaning.jpg?s=612x612&w=0&k=20&c=G95Es7imAsqRiLFZlqXFkTA24JLWAKmLdhtJLDYWZo0=";
const imageThree = "https://media.istockphoto.com/id/1090459638/photo/driveway-pressure-washing.jpg?s=612x612&w=0&k=20&c=5Us6jQjjepljlkh2qs7hdSpLZvnnfPDrcFjJbyqm_XM=";
const imageFour = "https://media.istockphoto.com/id/1131454238/photo/brick-wall-pressure-washing.jpg?s=612x612&w=0&k=20&c=8g1gGb7zDFzUWGLFP1o20O_CDbGoTcvSL_GgxzxYTFY=";
const imageFive = "https://media.istockphoto.com/id/1134513285/photo/pressure-washing-job.jpg?s=612x612&w=0&k=20&c=-fTg-Opa5oqMnr96RcMrxyhLK0r5npaunlSZSFNeVJo=";

const socialMediaLink = 'https://www.eaglepressurewash.com/';

export const siteConfig = {
  title: "Eagle Pressure Wash LLC",
  metaDescription: "Eagle Pressure Wash LLC",
  theme: {
    primaryColor: "blue-500",
    secondaryColor: "gray-200",
    accentColor: "text-blue-500"
  },
  logo: {
    src: bizIcon,
    alt: "Eagle Pressure Wash LLC",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Eagle Pressure Wash",
    headline: "Pressure Washing Services",
    address: "4 Winged Foot Dr, Medford, 11763 NY",
    description: "Quality pressure washing services for your lovely home."
  },
  images: {
    business: {
      src: imageOne,
      alt: "Premium Pressure Washing Services",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description:
        "Eagle Pressure Wash LLC delivers top-quality pressure washing solutions for residential, commercial, industrial, and property maintenance projects throughout the Medford metro area."
    },
    {
      description:
        "Our team of skilled technicians is equipped to handle projects of any size and complexity, ensuring exceptional results and a seamless, hassle-free experience for our clients."
    },
    {
      description:
        "We are committed to exceeding expectations by providing professional, reliable, and high-quality pressure washing services that restore surfaces and enhance the curb appeal of your property."
    },
  ],
  services: {
    sectionTitle: "Our Services",
    description: "At Eagle Pressure Wash LLC, we are dedicated to providing exceptional pressure washing services that restore and enhance the beauty of your property. With years of experience in the industry, our team of trained professionals utilizes state-of-the-art equipment and eco-friendly cleaning solutions to effectively remove dirt, grime, mold, and stains from a variety of surfaces. We pride ourselves on our commitment to quality, reliability, and customer satisfaction, ensuring that every job is completed to the highest standards. Whether you need residential or commercial pressure washing, we are here to revitalize your outdoor spaces and make them shine like new!",
    callouts: [
      {
        name: 'Driveway & Sidewalk Cleaning',
        description: "Restore the pristine appearance of your walkways with our expert cleaning services.",
        imageSrc: imageTwo,
        imageAlt: 'Driveway being pressure washed',
      },
      {
        name: 'Deck & Patio Cleaning',
        description: 'Refinish cabinets for an updated, stylish look.',
        imageSrc: imageThree,
        imageAlt: 'Clean and refreshed deck and patio',
      },
      {
        name: 'Building Exterior Cleaning',
        description: 'Deep clean outdoor surfaces for a refreshed look.',
        imageSrc: imageFour,
        imageAlt: 'Building exterior being pressure washed',
      }
    ],
    otherServices: [
      "Parking Lot & Garage Cleaning",
      "Sidewalk & Entrace Cleaning",
      "House Exterior Washing",
      "Personalized Services",
      "Flexible Scheduling",
    ]
  },  
  about: {
    sectionTitle: "About Us",
    description: "At Eagle Pressure Wash LLC, we are a well-established pressure washing company with over 20 years of experience serving the Medford metro area. We offer a comprehensive range of services, including residential and commercial pressure washing, property maintenance, and new construction projects. Our team of trained professionals utilizes state-of-the-art equipment and eco-friendly cleaning solutions to effectively remove dirt, grime, mold, and stains from a variety of surfaces. We pride ourselves on our commitment to quality, reliability, and customer satisfaction, ensuring that every job is completed to the highest standards. Our website is designed to attract new clients and showcase our past work. Eagle Pressure Wash LLC stands out from the competition through its extensive experience and broad service offerings.",
    image: {
      src: imageFive,
      alt: "CK Rondon Painting team in action",
      width: 2432,
      height: 1442
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Medford, NY 13409, USA",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.947834825702!2d-75.2577!3d43.0779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e42b3c8c8c8c8d%3A0xabcdef123456789!2s4%20Winged%20Foot%20Dr%2C%20Medford%2C%20NY%2013409%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=4%20Winged%20Foot%20Drive,%20Medford,%20NY%2013409&ll=43.0779,-75.2577&q=4%20Winged%20Foot%20Drive,%20Medford,%20NY%2013409' 
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=4+Winged+Foot+Drive,+Medford,+NY+13409&form=HDRSC6&sp=1&pq=4+winged+foot+drive+medford+ny+13409&sc=0-0&qs=n&sk=&cvid=ABCDEF1234567890' 
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/4+Winged+Foot+Drive,+Medford,+NY+13409,+USA/@43.0779,-75.2577,15.26523397a,814.57589625d,35y,0h,0t,0r' 
      },
      { 
        name: 'Google Maps', 
        url: 'https://maps.app.goo.gl/YOUR_MEDFORD_MAP_LINK' 
      }
    ]
  },  
  contact: {
    sectionTitle: "Schedule a Free Consultation for Your Next Pressure Washing Project",
    description: "Ready to restore and enhance your property with our professional pressure washing services? Get in touch with us today to schedule a free consultation and bring your vision to life.",    
    socialLinks: {
      facebook: socialMediaLink,
      instagram: socialMediaLink,
      twitter: socialMediaLink,
      youtube: socialMediaLink,
      tiktok: socialMediaLink
    },
    contactNumbers: ["646-512-0862"],
    logo: bizIcon,
    emailRecipient: "greatdelivery21@gmail.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
